<template>
  <div class="wrap">
    <div v-for="(item, index) in list" :key="index" class="item-wrap">
      <div class="icon-wrap">
        <el-image
          style="width: 100%; height: 100%"
          fit="contain"
          :src="item.icon"
        ></el-image>
      </div>
      <div class="content">{{ item.title }}</div>
    </div>
    <!-- <ul class="service clearfix">
      <li>
        <h3>专精专供</h3>
        <p>严选工厂&nbsp;&nbsp;&nbsp;&nbsp;直供零售</p>
        <span>专</span>
      </li>
      <li>
        <h3>品类丰富</h3>
        <p>全车配件&nbsp;&nbsp;&nbsp;&nbsp;一站购齐</p>
        <span>全</span>
      </li>
      <li>
        <h3>正品保障</h3>
        <p>品质护航&nbsp;&nbsp;&nbsp;&nbsp;正品保障</p>
        <span>正</span>
      </li>
      <li>
        <h3>售后无忧</h3>
        <p>自营严选&nbsp;&nbsp;&nbsp;&nbsp;平台质保</p>
        <span>保</span>
      </li>
    </ul> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [
        {
          icon: require("@/assets/bottom/qicao.png"),
          title: "国家标准起草单位",
        },
        {
          icon: require("@/assets/bottom/fangwei.png"),
          title: "防伪溯源品质保障",
        },
        {
          icon: require("@/assets/bottom/zhijian.png"),
          title: "原厂原件层层质检",
        },
        {
          icon: require("@/assets/bottom/baoyou.png"),
          title: "配件包邮售后无忧",
        },
      ],
    };
  },
};
</script>
<style lang="scss" scoped>
.wrap {
  display: grid;
  grid-template-columns: repeat(4, auto);
  padding-top: 60px;
  padding-bottom: 40px;
  padding-right: 50px;
  padding-left: 50px;
  justify-content: space-between;
  border-bottom: 2px solid rgba(194, 194, 194, 1);    
  .item-wrap {
    display: flex;
    align-items: center;
    .icon-wrap {
      height: 78px;
      width: 78px;
    }
    .content {
      margin-left: 15px;
      width: 96px;
      font-size: 24px;
      font-weight: 400;
      color: rgba(35, 35, 35, 1);
    }
  }
}
// .service {
//   padding: 20px 0;
//   border-bottom: 1px solid #ccc;
//   display: grid;
//   grid-template-columns: repeat(4, auto);
//   justify-content: space-around;
//   // display: flex;
//   // justify-content: space-around;
//   > li {
//     position: relative;
//     // float: left;
//     -webkit-box-sizing: border-box;
//     box-sizing: border-box;
//     // width: 246px;
//     // height: 50px;
//     padding-left: 65px;
//     // margin-left: 51px;
//     line-height: 24px;
//     h3 {
//       margin-bottom: 2px;
//       color: #1a1a1a;
//       font-weight: bold;
//       font-size: 14px;
//       line-height: 24px;
//     }
//     span {
//       position: absolute;
//       top: 0;
//       left: 0;
//       box-sizing: border-box;
//       width: 50px;
//       height: 50px;
//       border: 2px solid #ff4f1a;
//       border-radius: 50%;
//       color: #ff4f1a;
//       font-weight: bold;
//       font-size: 24px;
//       line-height: 44px;
//       text-align: center;
//     }
//   }
// }
</style>
